// Module
var code = "<mm-loading is-loading=\"$ctrl.response.isLoading\"></mm-loading> <mm-error ng-model=\"$ctrl.response\"></mm-error>";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Components/Indicators/LoadingError/LoadingError.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;